import { applyMiddleware, combineReducers, createStore, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';

import { callAPIMiddleware } from '@mq/aurora-redux-middleware/src/call-API-middleware';

import { IRealmState, realm } from '@mq/aurora-launcher-core';

export interface ILoginStore {
  realm: IRealmState;
}

export const createLoginStore = (): Store<ILoginStore> => {
  const middleware = [thunkMiddleware, callAPIMiddleware];

  const store = createStore(
    combineReducers<ILoginStore>({
      realm
    }),
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    composeWithDevTools(applyMiddleware(...middleware))
  );

  return store;
};
